import { Component } from '@angular/core';

@Component({
  selector: 'app-meter-icon',
  templateUrl: './meter-icon.component.svg',
  styleUrls: ['./meter-icon.component.scss']
})
export class MeterIconComponent
{

  constructor() { }

}
